import React, {useEffect, useState} from 'react';
import {consignorService, deliveriesService, distributionCenterService} from '../../../services';
import {Modal, notification, Button, Spin, Col, Row} from 'antd';
import SelectField from "../../select-field";
import { userServices } from '../../../services';
import { FULL_ACCESS_TO_OTHER_CONSIGNORS_DELIVERIES } from '../../../helpers/user_permission.helper';
import i18n from "../../../i18n";

export default function ModalChangeDeliveryShipperCompany({isShow, setIsShow, setIsNeedUpdate, setStopListUpdate, currentShipperCompany, currentDistCenter, deliveryID, deliveryConsignorId}) {
    const user = userServices.getUser();
  const [loading, setLoading] = useState(true);

  const [newShipperCompany, setNewShipperCompany] = useState(null);
  const [newDistCenter, setNewDistCenter] = useState(null);

  const [shipperCompaniesList, setShipperCompaniesList] = useState([]);
  const [distCentersList, setDistCentersList] = useState([]);

  const [fieldsErrors, setFieldsErrors] = useState([]);
  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined")
      ? fieldsErrors[nameField][0]
      : null;
  };

    const isFullAccess = user.isAccessTo(FULL_ACCESS_TO_OTHER_CONSIGNORS_DELIVERIES);



  useEffect(() => {
    setNewShipperCompany(currentShipperCompany);
    setNewDistCenter(currentDistCenter);
  }, [currentShipperCompany, currentDistCenter]);

  useEffect(() => {
    if (isShow) {
      setLoading(true);
            if (!isFullAccess) {
                deliveryConsignorId = null
            }
      consignorService
                .getShipperCompaniesList(deliveryConsignorId)
        .then(resp => {
          setShipperCompaniesList(resp);
        })
        .catch(err => {
          notification.error({
            message: i18n.t('components.notification.titles.getShipperCompaniesList'),
            description: err
          });
        });

      distributionCenterService
                .getCompanies(false, false, deliveryConsignorId)
        .then(resp => {
          setDistCentersList(resp);
        })
        .catch(err => {
          notification.error({
            message: i18n.t('components.notification.titles.getCompanies'),
            description: err
          });
        });
    }
  }, [isShow]);

  useEffect(() => {
    if (shipperCompaniesList && distCentersList) {
      setLoading(false);
    }
  }, [shipperCompaniesList, distCentersList]);

  const handleSubmit = () => {
    if (deliveryID) {
      setLoading(true);
      deliveriesService.changeShipperCompany(deliveryID, newShipperCompany, newDistCenter)
        .then(resp => {
          notification.success({
            message: i18n.t('components.notification.titles.changeShipperCompany'),
            description: resp.message
          });
          setIsShow(false);
          setIsNeedUpdate(true);
          setStopListUpdate(false);
        })
        .catch(err => {
          notification.error({
            message: i18n.t('components.notification.titles.changeShipperCompany'),
            description: err
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  return (
    <Modal
      title={i18n.t('modals.modalChangeDeliveryShipperCompany.title')}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      footer={[
        <Button onClick={handleSubmit} className="small-button typical-btn-green">{i18n.t('main.buttons.save')}</Button>
      ]}
    >
      <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
        <Row gutter={[16, 24]}>
          <Col lg={12} md={24} sm={24} sx={24}>
            <SelectField
              title={i18n.t('modals.modalChangeDeliveryShipperCompany.fields.shipperCompanyID.title')}
              name="shipperCompanyID"
              selectedValue={newShipperCompany}
              values={shipperCompaniesList}
              onChange={value => {
                setNewShipperCompany(value);
              }}
              getErrors={getFieldErrors}
              style={{width: "100%"}}
            />
          </Col>

          <Col lg={12} md={24} sm={24} sx={24}>
            <SelectField
              title={i18n.t('modals.modalChangeDeliveryShipperCompany.fields.distributionCenterID.title')}
              name="distributionCenterID"
              selectedValue={newDistCenter}
              values={distCentersList}
              onChange={value => {
                setNewDistCenter(value);
              }}
              getErrors={getFieldErrors}
              style={{width: "100%"}}
            />
          </Col>
        </Row>
      </Spin>
    </Modal>
  );

}
